import PortalLearningPath from '@classes/LearningPath'
import PortalLearningPathUnit from '@classes/LearningPathUnit'
import { Consumer } from '@layouts/LearningPath/Context'
import React from 'react'
export interface WithLearningPathContextProps {
  active: Boolean
  activeHover: Boolean
  playVideo: string
  activeId?: number
  setActive: (active: number) => void
  setActiveHover: (activeHover: number) => void
  setPlayVideo: (playVideo: string) => void
}

interface PanelProps {
  Unit?: PortalLearningPathUnit
  Path: PortalLearningPath
  children?: React.ReactNode
}

const WithLearningPathContext = (Component: React.ComponentType<any>) =>
  React.memo((props: PanelProps) => {
    return (
      <Consumer>
        {({ active, activeHover, playVideo, setActive, setActiveHover, setPlayVideo }) => {
          return (
            <Component
              {...props}
              active={props?.Unit?.Id === active}
              activeId={active}
              activeHover={props?.Unit?.Id === activeHover}
              playVideo={playVideo}
              setActive={setActive}
              setActiveHover={setActiveHover}
              setPlayVideo={setPlayVideo}
            />
          )
        }}
      </Consumer>
    )
  })

export default WithLearningPathContext
